export type INodeCategoryEnum = 'CONTROL' | 'LOGIC' | 'EXTERNAL' | 'MEMORY' | 'PLUGIN' | 'DEV_TOOL' | 'TEXT_TOOL' | 'IMAGE_TOOL' | 'VOICE_TOOL';

export interface INodeTemplate {
  category: INodeCategoryEnum;
  name: string;
  code: string;
  toolCode?: string;
  hidden?: boolean;
  icon?: React.ReactNode;
}